<div class="message-status"></div>

<div class="message-body">
  <p>{{ data.body }}</p>
  @if (data.errors?.length > 0) {
    <ul class="error-list">
      @for (error of data.errors; track error) {
        <li class="error-item">
          <fa-icon
            class="error-list-icon"
            [icon]="['fas', 'exclamation-triangle']"
          ></fa-icon>
          {{ error }}
        </li>
      }
    </ul>
  }
</div>

@if (data.action) {
  <button
    class="message-action"
    (click)="handleClick(data.onAction)"
    >
    {{ data.action }}
  </button>
}
<button
  class="message-close"
  mat-icon-button
  (click)="handleClick(data.onClose)"
  >
  <fa-icon class="message-close-icon" [icon]="['fas', 'times']"></fa-icon>
</button>
